let isAddedRoute = false
/**
 * authPluginForRouter
 * @param {import('vue-rotuer').default} router router instance
 */

// eslint-disable-next-line sonarjs/cognitive-complexity
export function install(router, config) {
  const { RouterAuth } = config
  if (!RouterAuth) {
    throw new Error('[tellus-router-auth]: config of "RouterAuth" is not exist!!')
  }

  const {
    /** @type {String} */
    loginPath,
    /** @type {String} */
    errorPath,
    /** @type {String} */
    homePath,
    /** @type {String[]} */
    whitePathList,
    /** @type {Function} */
    hasPermission,
    /** @type {Promise} */
    getAccessRoutes,
    /** @type {Promise} */
    errorHandler
  } = RouterAuth
  router.beforeEach(async (to, from, next) => {
    // Jump to the 404 page after processing the login
    if (from.path === loginPath && to.path === errorPath) {
      next(homePath)
      return
    }
    // Whitelist can be directly entered
    if (to.path === loginPath || (whitePathList && Array.isArray(whitePathList) && whitePathList.includes(to.path))) {
      // reset added router flag
      isAddedRoute = false
      next()
      return
    }
    // don`t have permission
    if (!hasPermission()) {
      // reset added router flag
      isAddedRoute = false
      next({
        path: loginPath,
        replace: true
      })
      return
    }
    // routes map has added
    if (typeof isAddedRoute !== 'undefined' && isAddedRoute) {
      if (!to.matched.length) {
        next(errorPath)
        return
      }
      next()
      return
    }

    try {
      // generate accessible routes map based on roles
      const accessRoutes = await getAccessRoutes()
      // dynamically add accessible routes
      accessRoutes.forEach(route => router.addRoute(route))

      isAddedRoute = true

      // redirect path
      const redirect = decodeURIComponent(from.query.redirect || to.path)

      // set the replace: true so the navigation will not leave a history record
      const nextRoute = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      // Jump to target route
      next(nextRoute)
      return
    } catch (error) {
      // logError
      // eslint-disable-next-line no-console
      console.error(error || 'Has Error')
      // reset added router flag
      isAddedRoute = false
      // remove token and go to login page to re-login
      if (errorHandler && typeof errorHandler === 'function') {
        errorHandler()
      }
      // Jump to login route
      next(loginPath)
      return
    }
  })
}
